export default __webpack_public_path__ + "static/media/05.fea772f7.jpg";